export { default as DeliveryTerms } from './delivery-terms';
